import { transformPost } from '../../../chunk-4DVXBYWE.mjs';
import { useRequest } from '../../../chunk-XVMGU2BE.mjs';
import '../../../chunk-DVP3QZCO.mjs';
import '../../../chunk-HICOKWLH.mjs';
import '../../../chunk-SURNML2O.mjs';
import '../../../chunk-6VIAYNGO.mjs';
import '../../../chunk-CI2YV475.mjs';
import '../../../chunk-WDGAR7LI.mjs';
import '../../../chunk-TTQ65QRH.mjs';
import '../../../chunk-JWOI4Q4B.mjs';
import '../../../chunk-HVKTN277.mjs';
import '../../../chunk-TVGQRSFH.mjs';
import '../../../chunk-AR63MRLK.mjs';
import '../../../chunk-U2EKEPPW.mjs';
import '../../../chunk-CPSF4ZEC.mjs';
import { graphql } from '../../../chunk-FNXRYVXB.mjs';
import '../../../chunk-GRW5ATLE.mjs';
import '../../../chunk-YUBKM3FG.mjs';

// src/til/query-hooks/post-detail/index.ts
var postDetailQuery = graphql(
  /* GraphQL */
  `
  query Post($id: uuid!) @cached {
    posts_by_pk(id: $id) {
      title
      readTimeInMinutes
      markdownContent
      id
      brief
      slug
    }
  }
`
);
var useLoadPostDetail = (id) => {
  const { data, isLoading, error } = useRequest({
    queryKey: ["post", id],
    document: postDetailQuery,
    variables: {
      id
    }
  });
  return {
    post: (data == null ? void 0 : data.posts_by_pk) ? transformPost(data.posts_by_pk) : null,
    isLoading,
    error
  };
};

export { useLoadPostDetail };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.mjs.map